import React, { useState, useEffect } from "react";
import { useQuery } from "graphql-hooks";
import { Helmet } from "react-helmet";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  CardActionArea,
  Container,
  Divider,
  Grid,
  Typography,
  Button,
  FormHelperText,
  TextField,
  IconButton,
  makeStyles,
} from "@material-ui/core";

import UserTeamSelectorApp from "./userTs/UserTeamSelectorApp";
import UserTeamSelectorAppMobile from "./userTsMobile/UserTeamSelectorAppMobile";
import UserTeamSelectorAppTablet from "./userTsTablet/UserTeamSelectorAppTablet";

import { ACCESS_FIXURE_TEAM_ID_QUERY } from "../../graphQL/authorized_user";
import { TS_BY_FOOTY_EXISTS_QUERY } from "../../graphQL/footy_qry";

const useStyles = makeStyles(theme => ({
  cardContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 80,
    paddingTop: 40,
    minWidth: 1366,
    minHeight: 458,
    backgroundColor: "#FFFFFF"
  },
  cardContainerTablet: {
    paddingBottom: 38,
    paddingTop: 10,
    paddingLeft: 48,
    paddingRight: 48,
    maxWidth: 900,
    //  height: 648,
  },
  cardContainerMobile: {
    paddingBottom: 38,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
  cardContent: {
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
  },
  cardContentTablet: {
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
  },
  cardTablet: {
    display: "flex",
    flexDirection: "column",
    minHeight: 648,
  },
  cardMobile: {
    display: "flex",
    flexDirection: "column",
    minHeight: 768,
  },
  cardContentMobile: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    paddingTop: 40,
    minHeight: 400,
  },
}));

const FootyView = () => {
  const classes = useStyles();
  const { footyNo} = useParams();
  const [showTS, setShowTS] = useState(false);
  const [state, setState] = useState({
    mobileView: false,
    tabletView: false,
  });
  const { mobileView, tabletView } = state;
  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 768
        ? setState(() => ({ mobileView: true }))
        : window.innerWidth < 963 && window.innerWidth > 767
        ? setState(() => ({ mobileView: false, tabletView: true }))
        : setState(() => ({ tabletView: false }));
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);


  const { loading, error, data } = useQuery(TS_BY_FOOTY_EXISTS_QUERY, {
    variables: {
      fixtureTeamId: parseInt(footyNo.substring(46)),
      userSeq: footyNo.substring(0, 46)
    },
  });

  useEffect(() => {
    if (!loading && data && data.tsByFootyExists) {
      setShowTS(true);
    }
  }, [data]);
  if (!showTS) {
    return (
      <h3>
        <br />
        <center>

        </center>
      </h3>
    );
  }

  return (
    <>
      <Helmet>
        <title>Predictal | Footy No Team Selection View</title>        
      </Helmet>

      {mobileView && (
        <Container className={classes.cardContainerMobile} maxWidth="xs">
          <UserTeamSelectorAppMobile />
        </Container>
      )}

      {tabletView && (
        <Container className={classes.cardContainerTablet} maxWidth="md">
          <UserTeamSelectorAppTablet />
        </Container>
      )}

      {!mobileView && !tabletView && (
        <Container className={classes.cardContainer} maxWidth="lg">
          <UserTeamSelectorApp />
        </Container>
      )}
    </>
  );
};

export default FootyView;
